// // document.addEventListener("DOMContentLoaded", function() {
// //   var endlessScroll = new Ajaxinate({
// //     container: '#product-grid',
// //     pagination: '#Huratips-Pagination'
// //     // method: 'click'
// //   });
// // });

// // document.addEventListener("DOMContentLoaded", function() {
// //   var endlessScroll = new Ajaxinate({
// //     container: '.grid.product-grid',
// //     pagination: '#Huratips-PaginationSearch'
// //     // method: 'click'
// //   });
// // });


// // $(document).ready(function(){
// //   $('.image-productSlider_productMain').slick({
// //     dots: false,
// //     infinite: false,
// //     speed: 300,
// //     slidesToShow: 1,
// //     slidesToScroll: 1,
// //     arrows:true,
// //     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
// //     nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
// //   });


  
// //   $('.itg-slideshowBanner_main').slick({
// //     dots: false,
// //     infinite: false,
// //     speed: 300,
// //     // slidesToShow: 1,
// //     slidesToScroll: 1,
// //     arrows:false,
// //     variableWidth: true,
// //     responsive: [
// //       {
// //         breakpoint: 990,
// //         settings: {
// //           slidesToShow: 1,
// //           slidesToScroll: 1,
// //           variableWidth: false,
// //           arrows: true,
// //           prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
// //           nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
// //         }
// //       },
// //       {
// //         breakpoint: 499,
// //         settings: {
// //           slidesToShow: 1,
// //           slidesToScroll: 1,
// //           variableWidth: false,
// //           arrows: false,
// //           dots: true
// //         }
// //       }
// //     ]
// //   });


// //   $('.itg-featured_collection').slick({
// //     dots: false,
// //     infinite: false,
// //     speed: 300,
// //     // slidesToShow: 1,
// //     slidesToScroll: 1,
// //     arrows:false,
// //     autoplay: true,
// //     autoplaySpeed: 3000,
// //     responsive: [
// //       {
// //         breakpoint: 990,
// //         settings: {
// //           slidesToShow: 3,
// //           slidesToScroll: 1
// //         }
// //       },
// //       {
// //         breakpoint: 767,
// //         settings: {
// //           slidesToShow: 2,
// //           slidesToScroll: 1
// //         }
// //       },
// //       {
// //         breakpoint: 479,
// //         settings: {
// //           slidesToShow: 1,
// //           slidesToScroll: 1
// //         }
// //       }
// //     ]
// //   });


// //   // $('.related-products .grid').slick({
// //   //   dots: false,
// //   //   infinite: false,
// //   //   speed: 300,
// //   //   // slidesToShow: 1,
// //   //   slidesToScroll: 1,
// //   //   arrows:false,
// //   //   autoplay: true,
// //   //   autoplaySpeed: 3000,
// //   //   responsive: [
// //   //     {
// //   //       breakpoint: 990,
// //   //       settings: {
// //   //         slidesToShow: 3,
// //   //         slidesToScroll: 1
// //   //       }
// //   //     },
// //   //     {
// //   //       breakpoint: 767,
// //   //       settings: {
// //   //         slidesToShow: 2,
// //   //         slidesToScroll: 1
// //   //       }
// //   //     }
// //   //   ]
// //   // });

// //   if(window.matchMedia("(max-width: 749px)").matches){
// //     $(document).on('click', '.footer .footer-block__heading', function(){
// //       $(this).siblings('.footer-block__details-content').slideToggle().parent().toggleClass('footerActive');
// //       $(this).parent().siblings('.footer-block').find('.footer-block__details-content').slideUp().parent().removeClass('footerActive');
// //     });
// //   }


// //   // $(document).on('click', '.js-load-more', function(){
// //   //   var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
// //   //   $this.attr('disabled', true);
// //   //   $this.find('[load-more-text]').addClass('hide');
// //   //   $this.find('[loader]').removeClass('hide');
// //   //   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
// //   //   $('[data-current-page]').val(currentPage);
// //   //   $.ajax({
// //   //     url: nextUrl,
// //   //     type: 'GET',
// //   //     dataType: 'html',
// //   //     success: function(responseHTML){
// //   //       console.log(responseHTML)
// //   //       var htmlNew = $(responseHTML).find('.product-grid-container .product-grid').html()
// //   //       $('.product-grid-container .product-grid').append(htmlNew);
// //   //     },
// //   //     complete: function() {
// //   //       if(currentPage <= totalPages) {
// //   //          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
// //   //       } 
// //   //     }
// //   //   })
// //   // });



// //   $('.product-bundled-products').slick({
// //       dots: false,
// //       infinite: false,
// //       speed: 300,
// //       slidesToShow: 2,
// //       slidesToScroll: 1,
// //       arrows: false,
// //       responsive: [
// //         {
// //           breakpoint: 1199,
// //           settings: {
// //           slidesToShow: 1,
// //           slidesToScroll: 1
// //           }
// //         },
// //         {
// //           breakpoint: 767,
// //           settings: {
// //           slidesToShow: 2,
// //           slidesToScroll: 1
// //           }
// //         }
// //       ]
// //     });


// //   $(document).on('click', '.facets__form .facets__heading', function(){
// //     $(this).parent().find('.itg-facetsFilter').toggle();
// //     $(this).toggleClass('active');
// //     $('body').toggleClass('facetOpen');
// //     if($(this).hasClass('active')){
// //       $('body .itg--overlay').addClass('show_overlay');
// //     }else{
// //       $('body .itg--overlay').removeClass('show_overlay');
// //     }
// //   });

// //   $(document).on('click', '.facets__form .sorting .facet-filters__label', function(){
// //     $(this).parent().find('.itg-sortByFiter').toggle();
// //     $(this).toggleClass('active');
// //     $('body').toggleClass('facetOpen');
// //     if($(this).hasClass('active')){
// //       $('body .itg--overlay').addClass('show_overlay');
// //     }else{
// //       $('body .itg--overlay').removeClass('show_overlay');
// //     }
// //   });

// //   $(document).on('click', '.facets__form .collectionsCategoryMobile .categoryHeading', function(){
// //     $(this).parent().find('.itg-collCategoryMain').toggle();
// //     $(this).toggleClass('active');
// //     $('body').toggleClass('facetOpen');
// //    if($(this).hasClass('active')){
// //       $('body .itg--overlay').addClass('show_overlay');
// //     }else{
// //       $('body .itg--overlay').removeClass('show_overlay');
// //     }
// //   });


// //   $(document).on('click', '.active-facets', function(){
// //       $('body .itg--overlay').removeClass('show_overlay');
// //   });

// //   $(document).on('click', '.link-labelled.linkLabelsubMenu span', function(e){
// //     e.preventDefault();
// //     $(this).parents('li').find('.subHeaderMenu.sub_slides').slideToggle();
// //     $(this).parent().toggleClass('subLinkActive');
// //     $(this).parents('li').siblings().find('.linkLabelsubMenu').removeClass('subLinkActive');
// //   });

// //   $(document).on('click', '.facets__form .text-body', function(){
// //     if($('.facets__form .text-body.active').length){
// //       $('.facets__form .text-body.active').parents('.facets__mainDiv').siblings('.facets__mainDiv').css('pointer-events', 'none');
// //     }else{
// //       $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
// //     }
// //   });

  

// //   // $(document).on('click', '.facets__disclosure', function(){
// //   //   setTimeout(function(){
// //   //   if($('body').hasClass('facetOpen')){
// //   //    $('body .itg--overlay').addClass('show_overlay');
// //   //   }else{
// //   //   }
// //   //   }, 1500);
// //   // });

// //   $(document).mouseup(function(e) {
// //   var container = $('#main-collection-filters, #main-search-filters');
// //   if (!container.is(e.target) && container.has(e.target).length === 0)
// //   { 
// //     $('.itg-facetsFilter, .itg-sortByFiter').hide();
// //     $('.itg-collCategoryMain').hide();
// //     $('.facets__form .text-body').removeClass('active');
// //     $('body').removeClass('facetOpen');
// //     $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
// //     $('body .itg--overlay').removeClass('show_overlay');
// //   }
// //   });

// //   // $(document).on('click', '.itg-filterMain .facets__summary', function(){
// //   //   $(this).parent().find('.facets__display').toggle();
// //   //   $(this).toggleClass('active');
// //   // });

// //   if(window.matchMedia("(max-width: 749px)").matches){
// //     $('.itg-filterMain .facets__disclosure').removeAttr('open');
// //   }

// //   $(".locator_nav_main a").on('click', function(event) { 
// //       event.preventDefault(); 
// //     var buttonUrl = $(this).attr('href');
// //     $('html, body').animate({
// //       // scrollTop: eval($(buttonUrl).offset().top - 140)
// //         scrollTop: $(buttonUrl).offset().top
// //     }, 1000);
      
// //   });

// //   $(".pageNavigationButton a").on('click', function(event) { 
// //       event.preventDefault(); 
// //     var buttonUrl = $(this).attr('href');
// //     $('html, body').animate({
// //       // scrollTop: eval($(buttonUrl).offset().top - 140)
// //         scrollTop: $(buttonUrl).offset().top
// //     }, 1000);
      
// //   });


// //   $(document).on('click', '.product-form__input input[type=radio]', function(){
// //     $('.product-form__input input').each(function(){
// //       if($(this).is(':checked')){
// //         var selectedVariant = $(this).val();
// //         $(this).parent().find('.form__label .productVariant__selectedOption').text(selectedVariant);
// //       }
// //     });
// //   });
  

  
  

// //   if(window.matchMedia("(max-width: 989px)").matches){
// //     $('.itg-announcementBar_main').slick({
// //       dots: false,
// //       infinite: true,
// //       speed: 300,
// //       slidesToShow: 1,
// //       slidesToScroll: 1,
// //       arrows:false,
// //       autoplay: true,
// //       autoplaySpeed: 3000,
// //       adaptiveHeight: true
// //     });


// //     $('.multicolumnMobileSliderMain').slick({
// //       dots: false,
// //       infinite: true,
// //       speed: 300,
// //       slidesToShow: 2,
// //       slidesToScroll: 1,
// //       arrows: false,
// //       autoplay: true,
// //       autoplaySpeed: 3000
// //     });    
// //   }



// // //   $(document).on('click', '#Huratips-Pagination a', function(){
// // //   setTimeout(function() {
// // //       $("#itg-cardContent").load(location.href + " #itg-cardContent");
// // //       console.log('refresh');
// // //     }, 5000);
// // //     setTimeout(function() {
// // //       var prodCount = $('a.text-m');
// // //       for(let i=0; i < prodCount.length; i++){
// // //         var revCount = prodCount[i].innerHTML;
// // //         var revsT = revCount.split(" ");
// // //         var finalRevC = revsT[0];
// // //         prodCount[i].innerHTML = finalRevC;
// // //         $('#yotpoStarsCat').css("display", "inline-block");   
// // //         console.log(finalRevC);
// // //       }
// // //     }, 7000);
// // // });


// //   $(document).on('click', '.cstm_swatches input[type=radio]', function(){
    
// //     var radioDataId = $(this).attr('media-id');
// //     console.log(radioDataId);
// //     $('.cardHiddenImages img').each(function(){
// //       var dataMediaId = $(this).attr('data-media-id');
// //       console.log(dataMediaId)
// //       if (radioDataId == dataMediaId){
// //         var ProductMedia = $(this).prop('outerHTML');
// //         console.log(ProductMedia)
// //         $(this).parents('.card__inner').find('.card__media .productMainImage').prop('outerHTML', ProductMedia)
// //       }
// //     });
// //   });



  
// //   $('.earring-quantity-selector > .earring-quantity-option').click(function() {
// //       $('.earring-quantity-selector > .earring-quantity-option').removeClass("active")
// //       $(".earring-quantity-input").val( $(this).attr('set-quantity') )
// //       $(this).addClass("active");
// //       var this_number = parseFloat($(this).attr('set-quantity'));
// //       var original_price = $('.product-price--wrapper .product-price--original').data('price').replace("€", "");
// //        original_price = parseFloat(original_price.replace(",", "."));
// //        var original_total = this_number * original_price;
// //         original_total = String( original_total ).replace(/\./g,',');
// //       $('.product-price--wrapper .product-price--original').html("€" + original_total);
// // //       console.log(String( original_total ).replace(/\./g,','));
// // //       alert(original_total);
// //     });


  
  
// // });


// //   document.addEventListener("scroll", function () {
// //     const header = document.querySelector(".header-wrapper");
// //     if (window.scrollY > window.innerHeight * 0.05) {
// //       header.classList.add("cstheader--scrolled");
// //     } else {
// //       header.classList.remove("cstheader--scrolled");
// //     }
// //   });



// //   // .....................Nacklace all in one product js........................

// //     function updateVariantContent() {

// //   var selectElement = document.querySelector("variant-selects .select .select__select");
// //   if (!selectElement) return;

// //   var currentValue = selectElement.value.trim();

// //   /* =========================
// //      GALLERY MATCHING
// //   ========================== */

// //   var mediaItems = document.querySelectorAll(
// //     ".cst-necklace-mn ul.product__media-list li.product__media-item.grid__item"
// //   );

// //   mediaItems.forEach(function(item) {

// //     var metaTitle = item.getAttribute("data-meta-title");

// //     item.classList.remove("activ_variantGlry");

// //     if (metaTitle && metaTitle.trim() === currentValue) {
// //       item.classList.add("activ_variantGlry");
// //     }

// //   });


// //   /* =========================
// //      DESCRIPTION MATCHING
// //   ========================== */

// //   var descriptionBlocks = document.querySelectorAll(
// //     ".cst-necklace-mn .product__accordion .description-block"
// //   );

// //   descriptionBlocks.forEach(function(block) {

// //     var descTitle = block.getAttribute("meta-desctitle");

// //     block.classList.remove("activ_variantDesc");

// //     if (descTitle && descTitle.trim() === currentValue) {
// //       block.classList.add("activ_variantDesc");
// //     }

// //   });

// // }

// // // Variant change event
// // document.addEventListener("change", function(e) {
// //   if (e.target.matches("variant-selects .select .select__select")) {
// //     updateVariantContent();
// //   }
// // });

// // // Page load pe bhi run kare
// // document.addEventListener("DOMContentLoaded", updateVariantContent);



// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '#product-grid',
//     pagination: '#Huratips-Pagination'
//     // method: 'click'
//   });
// });

// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '.grid.product-grid',
//     pagination: '#Huratips-PaginationSearch'
//     // method: 'click'
//   });
// });


// $(document).ready(function(){
//   $('.image-productSlider_productMain').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:true,
//     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//     nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
//   });


  
//   $('.itg-slideshowBanner_main').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     // slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:false,
//     variableWidth: true,
//     responsive: [
//       {
//         breakpoint: 990,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: false,
//           arrows: true,
//           prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//           nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
//         }
//       },
//       {
//         breakpoint: 499,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: false,
//           arrows: false,
//           dots: true
//         }
//       }
//     ]
//   });


//   $('.itg-featured_collection').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     // slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:false,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 990,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 479,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });


//   // $('.related-products .grid').slick({
//   //   dots: false,
//   //   infinite: false,
//   //   speed: 300,
//   //   // slidesToShow: 1,
//   //   slidesToScroll: 1,
//   //   arrows:false,
//   //   autoplay: true,
//   //   autoplaySpeed: 3000,
//   //   responsive: [
//   //     {
//   //       breakpoint: 990,
//   //       settings: {
//   //         slidesToShow: 3,
//   //         slidesToScroll: 1
//   //       }
//   //     },
//   //     {
//   //       breakpoint: 767,
//   //       settings: {
//   //         slidesToShow: 2,
//   //         slidesToScroll: 1
//   //       }
//   //     }
//   //   ]
//   // });

//   if(window.matchMedia("(max-width: 749px)").matches){
//     $(document).on('click', '.footer .footer-block__heading', function(){
//       $(this).siblings('.footer-block__details-content').slideToggle().parent().toggleClass('footerActive');
//       $(this).parent().siblings('.footer-block').find('.footer-block__details-content').slideUp().parent().removeClass('footerActive');
//     });
//   }


//   // $(document).on('click', '.js-load-more', function(){
//   //   var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
//   //   $this.attr('disabled', true);
//   //   $this.find('[load-more-text]').addClass('hide');
//   //   $this.find('[loader]').removeClass('hide');
//   //   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
//   //   $('[data-current-page]').val(currentPage);
//   //   $.ajax({
//   //     url: nextUrl,
//   //     type: 'GET',
//   //     dataType: 'html',
//   //     success: function(responseHTML){
//   //       console.log(responseHTML)
//   //       var htmlNew = $(responseHTML).find('.product-grid-container .product-grid').html()
//   //       $('.product-grid-container .product-grid').append(htmlNew);
//   //     },
//   //     complete: function() {
//   //       if(currentPage <= totalPages) {
//   //          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
//   //       } 
//   //     }
//   //   })
//   // });



//   $('.product-bundled-products').slick({
//       dots: false,
//       infinite: false,
//       speed: 300,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       responsive: [
//         {
//           breakpoint: 1199,
//           settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//           }
//         },
//         {
//           breakpoint: 767,
//           settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//           }
//         }
//       ]
//     });


//   $(document).on('click', '.facets__form .facets__heading', function(){
//     $(this).parent().find('.itg-facetsFilter').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//     if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });

//   $(document).on('click', '.facets__form .sorting .facet-filters__label', function(){
//     $(this).parent().find('.itg-sortByFiter').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//     if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });

//   $(document).on('click', '.facets__form .collectionsCategoryMobile .categoryHeading', function(){
//     $(this).parent().find('.itg-collCategoryMain').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//    if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });


//   $(document).on('click', '.active-facets', function(){
//       $('body .itg--overlay').removeClass('show_overlay');
//   });

//   $(document).on('click', '.link-labelled.linkLabelsubMenu span', function(e){
//     e.preventDefault();
//     $(this).parents('li').find('.subHeaderMenu.sub_slides').slideToggle();
//     $(this).parent().toggleClass('subLinkActive');
//     $(this).parents('li').siblings().find('.linkLabelsubMenu').removeClass('subLinkActive');
//   });

//   $(document).on('click', '.facets__form .text-body', function(){
//     if($('.facets__form .text-body.active').length){
//       $('.facets__form .text-body.active').parents('.facets__mainDiv').siblings('.facets__mainDiv').css('pointer-events', 'none');
//     }else{
//       $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
//     }
//   });

  

//   // $(document).on('click', '.facets__disclosure', function(){
//   //   setTimeout(function(){
//   //   if($('body').hasClass('facetOpen')){
//   //    $('body .itg--overlay').addClass('show_overlay');
//   //   }else{
//   //   }
//   //   }, 1500);
//   // });

//   $(document).mouseup(function(e) {
//   var container = $('#main-collection-filters, #main-search-filters');
//   if (!container.is(e.target) && container.has(e.target).length === 0)
//   { 
//     $('.itg-facetsFilter, .itg-sortByFiter').hide();
//     $('.itg-collCategoryMain').hide();
//     $('.facets__form .text-body').removeClass('active');
//     $('body').removeClass('facetOpen');
//     $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
//     $('body .itg--overlay').removeClass('show_overlay');
//   }
//   });

//   // $(document).on('click', '.itg-filterMain .facets__summary', function(){
//   //   $(this).parent().find('.facets__display').toggle();
//   //   $(this).toggleClass('active');
//   // });

//   if(window.matchMedia("(max-width: 749px)").matches){
//     $('.itg-filterMain .facets__disclosure').removeAttr('open');
//   }

//   $(".locator_nav_main a").on('click', function(event) { 
//       event.preventDefault(); 
//     var buttonUrl = $(this).attr('href');
//     $('html, body').animate({
//       // scrollTop: eval($(buttonUrl).offset().top - 140)
//         scrollTop: $(buttonUrl).offset().top
//     }, 1000);
      
//   });

//   $(".pageNavigationButton a").on('click', function(event) { 
//       event.preventDefault(); 
//     var buttonUrl = $(this).attr('href');
//     $('html, body').animate({
//       // scrollTop: eval($(buttonUrl).offset().top - 140)
//         scrollTop: $(buttonUrl).offset().top
//     }, 1000);
      
//   });


//   $(document).on('click', '.product-form__input input[type=radio]', function(){
//     $('.product-form__input input').each(function(){
//       if($(this).is(':checked')){
//         var selectedVariant = $(this).val();
//         $(this).parent().find('.form__label .productVariant__selectedOption').text(selectedVariant);
//       }
//     });
//   });
  

  
  

//   if(window.matchMedia("(max-width: 989px)").matches){
//     $('.itg-announcementBar_main').slick({
//       dots: false,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows:false,
//       autoplay: true,
//       autoplaySpeed: 3000,
//       adaptiveHeight: true
//     });


//     $('.multicolumnMobileSliderMain').slick({
//       dots: false,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       autoplay: true,
//       autoplaySpeed: 3000
//     });    
//   }



// //   $(document).on('click', '#Huratips-Pagination a', function(){
// //   setTimeout(function() {
// //       $("#itg-cardContent").load(location.href + " #itg-cardContent");
// //       console.log('refresh');
// //     }, 5000);
// //     setTimeout(function() {
// //       var prodCount = $('a.text-m');
// //       for(let i=0; i < prodCount.length; i++){
// //         var revCount = prodCount[i].innerHTML;
// //         var revsT = revCount.split(" ");
// //         var finalRevC = revsT[0];
// //         prodCount[i].innerHTML = finalRevC;
// //         $('#yotpoStarsCat').css("display", "inline-block");   
// //         console.log(finalRevC);
// //       }
// //     }, 7000);
// // });


//   $(document).on('click', '.cstm_swatches input[type=radio]', function(){
    
//     var radioDataId = $(this).attr('media-id');
//     console.log(radioDataId);
//     $('.cardHiddenImages img').each(function(){
//       var dataMediaId = $(this).attr('data-media-id');
//       console.log(dataMediaId)
//       if (radioDataId == dataMediaId){
//         var ProductMedia = $(this).prop('outerHTML');
//         console.log(ProductMedia)
//         $(this).parents('.card__inner').find('.card__media .productMainImage').prop('outerHTML', ProductMedia)
//       }
//     });
//   });



  
//   $('.earring-quantity-selector > .earring-quantity-option').click(function() {
//       $('.earring-quantity-selector > .earring-quantity-option').removeClass("active")
//       $(".earring-quantity-input").val( $(this).attr('set-quantity') )
//       $(this).addClass("active");
//       var this_number = parseFloat($(this).attr('set-quantity'));
//       var original_price = $('.product-price--wrapper .product-price--original').data('price').replace("€", "");
//        original_price = parseFloat(original_price.replace(",", "."));
//        var original_total = this_number * original_price;
//         original_total = String( original_total ).replace(/\./g,',');
//       $('.product-price--wrapper .product-price--original').html("€" + original_total);
// //       console.log(String( original_total ).replace(/\./g,','));
// //       alert(original_total);
//     });


  
  
// });



//   document.addEventListener("scroll", function () {
//     const header = document.querySelector(".header-wrapper");
//     if (window.scrollY > window.innerHeight * 0.05) {
//       header.classList.add("cstheader--scrolled");
//     } else {
//       header.classList.remove("cstheader--scrolled");
//     }
//   });



//   // .....................Nacklace all in one product js........................

//     function updateVariantContent() {

//   var selectElement = document.querySelector("variant-selects .select .select__select");
//   if (!selectElement) return;

//   var currentValue = selectElement.value.trim();

//   /* =========================
//      GALLERY MATCHING
//   ========================== */

//   var mediaItems = document.querySelectorAll(
//     ".cst-necklace-mn ul.product__media-list li.product__media-item.grid__item"
//   );

//   mediaItems.forEach(function(item) {

//     var metaTitle = item.getAttribute("data-meta-title");

//     item.classList.remove("activ_variantGlry");

//     if (metaTitle && metaTitle.trim() === currentValue) {
//       item.classList.add("activ_variantGlry");
//     }

//   });


//   /* =========================
//      DESCRIPTION MATCHING
//   ========================== */

//   var descriptionBlocks = document.querySelectorAll(
//     ".cst-necklace-mn .product__accordion .description-block"
//   );

//   descriptionBlocks.forEach(function(block) {

//     var descTitle = block.getAttribute("meta-desctitle");

//     block.classList.remove("activ_variantDesc");

//     if (descTitle && descTitle.trim() === currentValue) {
//       block.classList.add("activ_variantDesc");
//     }

//   });

// }

// // Variant change event
// document.addEventListener("change", function(e) {
//   if (e.target.matches("variant-selects .select .select__select")) {
//     updateVariantContent();
//   }
// });

// // Page load pe bhi run kare
// document.addEventListener("DOMContentLoaded", updateVariantContent);
 



// // --------------------Easy Appointment page js---------------------
// // setTimeout(() => {

//   // const buttons = document.querySelectorAll('.ai-location-cardMn button.ailocation-card__btn');
//   // console.log("Buttons:", buttons);

//   // buttons.forEach(button => {

//   //   button.addEventListener('click', function () {

//   //     let locationName = this.getAttribute('data-location-name').toLowerCase();
//   //     console.log("Location Name:", locationName);

//   //     const cards = document.querySelectorAll('.sc-bXCLTC.josnQa');

//   //     cards.forEach(card => {

//   //       const h2 = card.querySelector('h2.sc-fHjqPf.jpKJSD');

//   //       if (h2) {
//   //         let title = h2.textContent.trim().toLowerCase();
//   //         console.log("Title:", title);

//   //         if (title.includes(locationName)) {
//   //           console.log("MATCH FOUND:", locationName);
//   //           card.style.display = "block";
//   //         } else {
//   //           card.style.display = "none";
//   //         }

//   //       }

//   //     });

//   //     const gridView = document.querySelector('.eab-grid-view');
//   //     if (gridView) {
//   //       gridView.scrollIntoView({ behavior: 'smooth', block: 'start' });
//   //       console.log("Scrolled to .eab-grid-view");
//   //     }

//   //   });

//   // });

// // }, 3000); // 3 sec wait for app load


// setTimeout(() => { // Please do not remove the `setTimeout`.
// 		let activeChangeHandler = null;

// 		document.addEventListener('click', function(e) {
// 			const btn = e.target.closest('.ailocation-card__btn');
// 			if (!btn) return;

// 			document.querySelectorAll('.cstpiercing-service').forEach(el => {
// 				el.classList.remove('active');
		
// 				if (activeChangeHandler) {
// 					el.removeEventListener('change', activeChangeHandler);
// 				}
// 			});

// 			document.querySelectorAll('.ailocation-card__btn').forEach(el => {
// 				el.classList.remove('hidden');
// 			});

// 			btn.classList.add('hidden');
// 			const locationName = btn.getAttribute('data-location-name') || 'Not found';
// 			console.log('Clicked location:', locationName);

// 			const parent = btn.parentElement;
// 			if (!parent) return;

// 			const select = parent.querySelector('.cstpiercing-service');
// 			if (!select) return;

// 			select.classList.add('active');
// 			activeChangeHandler = function(e) {
// 				handleServiceChange(e, locationName);
// 			};

// 			select.addEventListener('change', activeChangeHandler, { once: false });
// 		});

// 		function handleServiceChange(e, locationFromButton) {
// 			const selectedValue = e.target.value.trim();
// 			if (!selectedValue) return;

// 			const location = locationFromButton || 'Unknown';

// 			console.log('Service selected:', selectedValue);
// 			console.log('For location:', location);

// 			checkAndClickMatchingTitle(location, selectedValue);
// 		}

// 		// function checkAndClickMatchingTitle(location, service) {
// 		// 	if (!location || !service || service === "") return;

// 		// 	const locLower  = location.toLowerCase().trim();
// 		// 	const servLower = service.toLowerCase().trim();

// 		// 	const headings = document.querySelectorAll('.eab-grid-view h2.sc-fHjqPf.jpKJSD');

// 		// 	let clickedAny = false;

// 		// 	headings.forEach(h2 => {
// 		// 		const titleText = h2.textContent.toLowerCase().trim();

// 		// 		const hasLocation = titleText.includes(locLower);
// 		// 		const hasService  = titleText.includes(servLower);

// 		// 		if (hasLocation && hasService) {
// 		// 			console.log(`Match found! Clicking: "${h2.textContent.trim()}"`);
// 		// 			h2.click();
// 		// 			clickedAny = true;
// 		// 		}
// 		// 	});

// 		// 	if (!clickedAny) {
// 		// 		console.log("No matching title found for →", { location, service });
// 		// 	}
// 		// }

//     function checkAndClickMatchingTitle(location, service) {
//   if (!location || !service) return;

//   const norm = (s) => s.toLowerCase().trim().replace(/\s+/g, ' ');
//   const wanted = norm(`${service} - ${location}`); // app format: "Service - Location"

//   // ❌ hashed class (sc-fHjqPf jpKJSD) hata di — app update pe badalti hai
//   // ✅ sirf h2 pakdo
//   const headings = document.querySelectorAll('.eab-grid-view h2');
//   if (!headings.length) {
//     console.warn('EAB headings nahi mile — app load nahi hua ya .eab-grid-view badla.');
//     return;
//   }

//   let clicked = false;
//   headings.forEach(h2 => {
//     if (norm(h2.textContent) === wanted) {   // exact match
//       console.log('Match found! Clicking:', h2.textContent.trim());
//       h2.click();
//       clicked = true;
//     }
//   });

//   if (!clicked) {
//     console.log('No exact match for →', wanted);
//   }
// }

// }, 3000); // Please do not remove the `this`.





















// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '#product-grid',
//     pagination: '#Huratips-Pagination'
//     // method: 'click'
//   });
// });

// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '.grid.product-grid',
//     pagination: '#Huratips-PaginationSearch'
//     // method: 'click'
//   });
// });


// $(document).ready(function(){
//   $('.image-productSlider_productMain').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:true,
//     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//     nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
//   });


  
//   $('.itg-slideshowBanner_main').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     // slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:false,
//     variableWidth: true,
//     responsive: [
//       {
//         breakpoint: 990,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: false,
//           arrows: true,
//           prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//           nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
//         }
//       },
//       {
//         breakpoint: 499,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           variableWidth: false,
//           arrows: false,
//           dots: true
//         }
//       }
//     ]
//   });


//   $('.itg-featured_collection').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     // slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows:false,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 990,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 479,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });


//   // $('.related-products .grid').slick({
//   //   dots: false,
//   //   infinite: false,
//   //   speed: 300,
//   //   // slidesToShow: 1,
//   //   slidesToScroll: 1,
//   //   arrows:false,
//   //   autoplay: true,
//   //   autoplaySpeed: 3000,
//   //   responsive: [
//   //     {
//   //       breakpoint: 990,
//   //       settings: {
//   //         slidesToShow: 3,
//   //         slidesToScroll: 1
//   //       }
//   //     },
//   //     {
//   //       breakpoint: 767,
//   //       settings: {
//   //         slidesToShow: 2,
//   //         slidesToScroll: 1
//   //       }
//   //     }
//   //   ]
//   // });

//   if(window.matchMedia("(max-width: 749px)").matches){
//     $(document).on('click', '.footer .footer-block__heading', function(){
//       $(this).siblings('.footer-block__details-content').slideToggle().parent().toggleClass('footerActive');
//       $(this).parent().siblings('.footer-block').find('.footer-block__details-content').slideUp().parent().removeClass('footerActive');
//     });
//   }


//   // $(document).on('click', '.js-load-more', function(){
//   //   var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
//   //   $this.attr('disabled', true);
//   //   $this.find('[load-more-text]').addClass('hide');
//   //   $this.find('[loader]').removeClass('hide');
//   //   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
//   //   $('[data-current-page]').val(currentPage);
//   //   $.ajax({
//   //     url: nextUrl,
//   //     type: 'GET',
//   //     dataType: 'html',
//   //     success: function(responseHTML){
//   //       console.log(responseHTML)
//   //       var htmlNew = $(responseHTML).find('.product-grid-container .product-grid').html()
//   //       $('.product-grid-container .product-grid').append(htmlNew);
//   //     },
//   //     complete: function() {
//   //       if(currentPage <= totalPages) {
//   //          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
//   //       } 
//   //     }
//   //   })
//   // });



//   $('.product-bundled-products').slick({
//       dots: false,
//       infinite: false,
//       speed: 300,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       responsive: [
//         {
//           breakpoint: 1199,
//           settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//           }
//         },
//         {
//           breakpoint: 767,
//           settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//           }
//         }
//       ]
//     });


//   $(document).on('click', '.facets__form .facets__heading', function(){
//     $(this).parent().find('.itg-facetsFilter').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//     if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });

//   $(document).on('click', '.facets__form .sorting .facet-filters__label', function(){
//     $(this).parent().find('.itg-sortByFiter').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//     if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });

//   $(document).on('click', '.facets__form .collectionsCategoryMobile .categoryHeading', function(){
//     $(this).parent().find('.itg-collCategoryMain').toggle();
//     $(this).toggleClass('active');
//     $('body').toggleClass('facetOpen');
//    if($(this).hasClass('active')){
//       $('body .itg--overlay').addClass('show_overlay');
//     }else{
//       $('body .itg--overlay').removeClass('show_overlay');
//     }
//   });


//   $(document).on('click', '.active-facets', function(){
//       $('body .itg--overlay').removeClass('show_overlay');
//   });

//   $(document).on('click', '.link-labelled.linkLabelsubMenu span', function(e){
//     e.preventDefault();
//     $(this).parents('li').find('.subHeaderMenu.sub_slides').slideToggle();
//     $(this).parent().toggleClass('subLinkActive');
//     $(this).parents('li').siblings().find('.linkLabelsubMenu').removeClass('subLinkActive');
//   });

//   $(document).on('click', '.facets__form .text-body', function(){
//     if($('.facets__form .text-body.active').length){
//       $('.facets__form .text-body.active').parents('.facets__mainDiv').siblings('.facets__mainDiv').css('pointer-events', 'none');
//     }else{
//       $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
//     }
//   });

  

//   // $(document).on('click', '.facets__disclosure', function(){
//   //   setTimeout(function(){
//   //   if($('body').hasClass('facetOpen')){
//   //    $('body .itg--overlay').addClass('show_overlay');
//   //   }else{
//   //   }
//   //   }, 1500);
//   // });

//   $(document).mouseup(function(e) {
//   var container = $('#main-collection-filters, #main-search-filters');
//   if (!container.is(e.target) && container.has(e.target).length === 0)
//   { 
//     $('.itg-facetsFilter, .itg-sortByFiter').hide();
//     $('.itg-collCategoryMain').hide();
//     $('.facets__form .text-body').removeClass('active');
//     $('body').removeClass('facetOpen');
//     $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
//     $('body .itg--overlay').removeClass('show_overlay');
//   }
//   });

//   // $(document).on('click', '.itg-filterMain .facets__summary', function(){
//   //   $(this).parent().find('.facets__display').toggle();
//   //   $(this).toggleClass('active');
//   // });

//   if(window.matchMedia("(max-width: 749px)").matches){
//     $('.itg-filterMain .facets__disclosure').removeAttr('open');
//   }

//   $(".locator_nav_main a").on('click', function(event) { 
//       event.preventDefault(); 
//     var buttonUrl = $(this).attr('href');
//     $('html, body').animate({
//       // scrollTop: eval($(buttonUrl).offset().top - 140)
//         scrollTop: $(buttonUrl).offset().top
//     }, 1000);
      
//   });

//   $(".pageNavigationButton a").on('click', function(event) { 
//       event.preventDefault(); 
//     var buttonUrl = $(this).attr('href');
//     $('html, body').animate({
//       // scrollTop: eval($(buttonUrl).offset().top - 140)
//         scrollTop: $(buttonUrl).offset().top
//     }, 1000);
      
//   });


//   $(document).on('click', '.product-form__input input[type=radio]', function(){
//     $('.product-form__input input').each(function(){
//       if($(this).is(':checked')){
//         var selectedVariant = $(this).val();
//         $(this).parent().find('.form__label .productVariant__selectedOption').text(selectedVariant);
//       }
//     });
//   });
  

  
  

//   if(window.matchMedia("(max-width: 989px)").matches){
//     $('.itg-announcementBar_main').slick({
//       dots: false,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows:false,
//       autoplay: true,
//       autoplaySpeed: 3000,
//       adaptiveHeight: true
//     });


//     $('.multicolumnMobileSliderMain').slick({
//       dots: false,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       autoplay: true,
//       autoplaySpeed: 3000
//     });    
//   }



// //   $(document).on('click', '#Huratips-Pagination a', function(){
// //   setTimeout(function() {
// //       $("#itg-cardContent").load(location.href + " #itg-cardContent");
// //       console.log('refresh');
// //     }, 5000);
// //     setTimeout(function() {
// //       var prodCount = $('a.text-m');
// //       for(let i=0; i < prodCount.length; i++){
// //         var revCount = prodCount[i].innerHTML;
// //         var revsT = revCount.split(" ");
// //         var finalRevC = revsT[0];
// //         prodCount[i].innerHTML = finalRevC;
// //         $('#yotpoStarsCat').css("display", "inline-block");   
// //         console.log(finalRevC);
// //       }
// //     }, 7000);
// // });


//   $(document).on('click', '.cstm_swatches input[type=radio]', function(){
    
//     var radioDataId = $(this).attr('media-id');
//     console.log(radioDataId);
//     $('.cardHiddenImages img').each(function(){
//       var dataMediaId = $(this).attr('data-media-id');
//       console.log(dataMediaId)
//       if (radioDataId == dataMediaId){
//         var ProductMedia = $(this).prop('outerHTML');
//         console.log(ProductMedia)
//         $(this).parents('.card__inner').find('.card__media .productMainImage').prop('outerHTML', ProductMedia)
//       }
//     });
//   });



  
//   $('.earring-quantity-selector > .earring-quantity-option').click(function() {
//       $('.earring-quantity-selector > .earring-quantity-option').removeClass("active")
//       $(".earring-quantity-input").val( $(this).attr('set-quantity') )
//       $(this).addClass("active");
//       var this_number = parseFloat($(this).attr('set-quantity'));
//       var original_price = $('.product-price--wrapper .product-price--original').data('price').replace("€", "");
//        original_price = parseFloat(original_price.replace(",", "."));
//        var original_total = this_number * original_price;
//         original_total = String( original_total ).replace(/\./g,',');
//       $('.product-price--wrapper .product-price--original').html("€" + original_total);
// //       console.log(String( original_total ).replace(/\./g,','));
// //       alert(original_total);
//     });


  
  
// });


//   document.addEventListener("scroll", function () {
//     const header = document.querySelector(".header-wrapper");
//     if (window.scrollY > window.innerHeight * 0.05) {
//       header.classList.add("cstheader--scrolled");
//     } else {
//       header.classList.remove("cstheader--scrolled");
//     }
//   });



//   // .....................Nacklace all in one product js........................

//     function updateVariantContent() {

//   var selectElement = document.querySelector("variant-selects .select .select__select");
//   if (!selectElement) return;

//   var currentValue = selectElement.value.trim();

//   /* =========================
//      GALLERY MATCHING
//   ========================== */

//   var mediaItems = document.querySelectorAll(
//     ".cst-necklace-mn ul.product__media-list li.product__media-item.grid__item"
//   );

//   mediaItems.forEach(function(item) {

//     var metaTitle = item.getAttribute("data-meta-title");

//     item.classList.remove("activ_variantGlry");

//     if (metaTitle && metaTitle.trim() === currentValue) {
//       item.classList.add("activ_variantGlry");
//     }

//   });


//   /* =========================
//      DESCRIPTION MATCHING
//   ========================== */

//   var descriptionBlocks = document.querySelectorAll(
//     ".cst-necklace-mn .product__accordion .description-block"
//   );

//   descriptionBlocks.forEach(function(block) {

//     var descTitle = block.getAttribute("meta-desctitle");

//     block.classList.remove("activ_variantDesc");

//     if (descTitle && descTitle.trim() === currentValue) {
//       block.classList.add("activ_variantDesc");
//     }

//   });

// }

// // Variant change event
// document.addEventListener("change", function(e) {
//   if (e.target.matches("variant-selects .select .select__select")) {
//     updateVariantContent();
//   }
// });

// // Page load pe bhi run kare
// document.addEventListener("DOMContentLoaded", updateVariantContent);



document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#Huratips-Pagination'
    // method: 'click'
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '.grid.product-grid',
    pagination: '#Huratips-PaginationSearch'
    // method: 'click'
  });
});


$(document).ready(function(){
  $('.image-productSlider_productMain').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
  });


  
  $('.itg-slideshowBanner_main').slick({
    dots: false,
    infinite: false,
    speed: 300,
    // slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true,
          prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M15 18.1001L9 12.1001L15 6.1001" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M9 18.3088L15 12.3088L9 6.30884" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        }
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: false,
          dots: true
        }
      }
    ]
  });


  $('.itg-featured_collection').slick({
    dots: false,
    infinite: false,
    speed: 300,
    // slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  // $('.related-products .grid').slick({
  //   dots: false,
  //   infinite: false,
  //   speed: 300,
  //   // slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows:false,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   responsive: [
  //     {
  //       breakpoint: 990,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  if(window.matchMedia("(max-width: 749px)").matches){
    $(document).on('click', '.footer .footer-block__heading', function(){
      $(this).siblings('.footer-block__details-content').slideToggle().parent().toggleClass('footerActive');
      $(this).parent().siblings('.footer-block').find('.footer-block__details-content').slideUp().parent().removeClass('footerActive');
    });
  }


  // $(document).on('click', '.js-load-more', function(){
  //   var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  //   $this.attr('disabled', true);
  //   $this.find('[load-more-text]').addClass('hide');
  //   $this.find('[loader]').removeClass('hide');
  //   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  //   $('[data-current-page]').val(currentPage);
  //   $.ajax({
  //     url: nextUrl,
  //     type: 'GET',
  //     dataType: 'html',
  //     success: function(responseHTML){
  //       console.log(responseHTML)
  //       var htmlNew = $(responseHTML).find('.product-grid-container .product-grid').html()
  //       $('.product-grid-container .product-grid').append(htmlNew);
  //     },
  //     complete: function() {
  //       if(currentPage <= totalPages) {
  //          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
  //       } 
  //     }
  //   })
  // });



  $('.product-bundled-products').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1
          }
        }
      ]
    });


  $(document).on('click', '.facets__form .facets__heading', function(){
    $(this).parent().find('.itg-facetsFilter').toggle();
    $(this).toggleClass('active');
    $('body').toggleClass('facetOpen');
    if($(this).hasClass('active')){
      $('body .itg--overlay').addClass('show_overlay');
    }else{
      $('body .itg--overlay').removeClass('show_overlay');
    }
  });

  $(document).on('click', '.facets__form .sorting .facet-filters__label', function(){
    $(this).parent().find('.itg-sortByFiter').toggle();
    $(this).toggleClass('active');
    $('body').toggleClass('facetOpen');
    if($(this).hasClass('active')){
      $('body .itg--overlay').addClass('show_overlay');
    }else{
      $('body .itg--overlay').removeClass('show_overlay');
    }
  });

  $(document).on('click', '.facets__form .collectionsCategoryMobile .categoryHeading', function(){
    $(this).parent().find('.itg-collCategoryMain').toggle();
    $(this).toggleClass('active');
    $('body').toggleClass('facetOpen');
   if($(this).hasClass('active')){
      $('body .itg--overlay').addClass('show_overlay');
    }else{
      $('body .itg--overlay').removeClass('show_overlay');
    }
  });


  $(document).on('click', '.active-facets', function(){
      $('body .itg--overlay').removeClass('show_overlay');
  });

  $(document).on('click', '.link-labelled.linkLabelsubMenu span', function(e){
    e.preventDefault();
    $(this).parents('li').find('.subHeaderMenu.sub_slides').slideToggle();
    $(this).parent().toggleClass('subLinkActive');
    $(this).parents('li').siblings().find('.linkLabelsubMenu').removeClass('subLinkActive');
  });

  $(document).on('click', '.facets__form .text-body', function(){
    if($('.facets__form .text-body.active').length){
      $('.facets__form .text-body.active').parents('.facets__mainDiv').siblings('.facets__mainDiv').css('pointer-events', 'none');
    }else{
      $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
    }
  });

  

  // $(document).on('click', '.facets__disclosure', function(){
  //   setTimeout(function(){
  //   if($('body').hasClass('facetOpen')){
  //    $('body .itg--overlay').addClass('show_overlay');
  //   }else{
  //   }
  //   }, 1500);
  // });

  $(document).mouseup(function(e) {
  var container = $('#main-collection-filters, #main-search-filters');
  if (!container.is(e.target) && container.has(e.target).length === 0)
  { 
    $('.itg-facetsFilter, .itg-sortByFiter').hide();
    $('.itg-collCategoryMain').hide();
    $('.facets__form .text-body').removeClass('active');
    $('body').removeClass('facetOpen');
    $('.facets__form .text-body').parents('.facets__mainDiv').css('pointer-events', 'all');
    $('body .itg--overlay').removeClass('show_overlay');
  }
  });

  // $(document).on('click', '.itg-filterMain .facets__summary', function(){
  //   $(this).parent().find('.facets__display').toggle();
  //   $(this).toggleClass('active');
  // });

  if(window.matchMedia("(max-width: 749px)").matches){
    $('.itg-filterMain .facets__disclosure').removeAttr('open');
  }

  $(".locator_nav_main a").on('click', function(event) { 
      event.preventDefault(); 
    var buttonUrl = $(this).attr('href');
    $('html, body').animate({
      // scrollTop: eval($(buttonUrl).offset().top - 140)
        scrollTop: $(buttonUrl).offset().top
    }, 1000);
      
  });

  $(".pageNavigationButton a").on('click', function(event) { 
      event.preventDefault(); 
    var buttonUrl = $(this).attr('href');
    $('html, body').animate({
      // scrollTop: eval($(buttonUrl).offset().top - 140)
        scrollTop: $(buttonUrl).offset().top
    }, 1000);
      
  });


  $(document).on('click', '.product-form__input input[type=radio]', function(){
    $('.product-form__input input').each(function(){
      if($(this).is(':checked')){
        var selectedVariant = $(this).val();
        $(this).parent().find('.form__label .productVariant__selectedOption').text(selectedVariant);
      }
    });
  });
  

  
  

  if(window.matchMedia("(max-width: 989px)").matches){
    $('.itg-announcementBar_main').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: true
    });


    $('.multicolumnMobileSliderMain').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000
    });    
  }



//   $(document).on('click', '#Huratips-Pagination a', function(){
//   setTimeout(function() {
//       $("#itg-cardContent").load(location.href + " #itg-cardContent");
//       console.log('refresh');
//     }, 5000);
//     setTimeout(function() {
//       var prodCount = $('a.text-m');
//       for(let i=0; i < prodCount.length; i++){
//         var revCount = prodCount[i].innerHTML;
//         var revsT = revCount.split(" ");
//         var finalRevC = revsT[0];
//         prodCount[i].innerHTML = finalRevC;
//         $('#yotpoStarsCat').css("display", "inline-block");   
//         console.log(finalRevC);
//       }
//     }, 7000);
// });


  $(document).on('click', '.cstm_swatches input[type=radio]', function(){
    
    var radioDataId = $(this).attr('media-id');
    console.log(radioDataId);
    $('.cardHiddenImages img').each(function(){
      var dataMediaId = $(this).attr('data-media-id');
      console.log(dataMediaId)
      if (radioDataId == dataMediaId){
        var ProductMedia = $(this).prop('outerHTML');
        console.log(ProductMedia)
        $(this).parents('.card__inner').find('.card__media .productMainImage').prop('outerHTML', ProductMedia)
      }
    });
  });



  
  $('.earring-quantity-selector > .earring-quantity-option').click(function() {
      $('.earring-quantity-selector > .earring-quantity-option').removeClass("active")
      $(".earring-quantity-input").val( $(this).attr('set-quantity') )
      $(this).addClass("active");
      var this_number = parseFloat($(this).attr('set-quantity'));
      var original_price = $('.product-price--wrapper .product-price--original').data('price').replace("€", "");
       original_price = parseFloat(original_price.replace(",", "."));
       var original_total = this_number * original_price;
        original_total = String( original_total ).replace(/\./g,',');
      $('.product-price--wrapper .product-price--original').html("€" + original_total);
//       console.log(String( original_total ).replace(/\./g,','));
//       alert(original_total);
    });


  
  
});



  document.addEventListener("scroll", function () {
    const header = document.querySelector(".header-wrapper");
    if (window.scrollY > window.innerHeight * 0.05) {
      header.classList.add("cstheader--scrolled");
    } else {
      header.classList.remove("cstheader--scrolled");
    }
  });



  // .....................Nacklace all in one product js........................

    function updateVariantContent() {

  var selectElement = document.querySelector("variant-selects .select .select__select");
  if (!selectElement) return;

  var currentValue = selectElement.value.trim();

  /* =========================
     GALLERY MATCHING
  ========================== */

  var mediaItems = document.querySelectorAll(
    ".cst-necklace-mn ul.product__media-list li.product__media-item.grid__item"
  );

  mediaItems.forEach(function(item) {

    var metaTitle = item.getAttribute("data-meta-title");

    item.classList.remove("activ_variantGlry");

    if (metaTitle && metaTitle.trim() === currentValue) {
      item.classList.add("activ_variantGlry");
    }

  });


  /* =========================
     DESCRIPTION MATCHING
  ========================== */

  var descriptionBlocks = document.querySelectorAll(
    ".cst-necklace-mn .product__accordion .description-block"
  );

  descriptionBlocks.forEach(function(block) {

    var descTitle = block.getAttribute("meta-desctitle");

    block.classList.remove("activ_variantDesc");

    if (descTitle && descTitle.trim() === currentValue) {
      block.classList.add("activ_variantDesc");
    }

  });

}

// Variant change event
document.addEventListener("change", function(e) {
  if (e.target.matches("variant-selects .select .select__select")) {
    updateVariantContent();
  }
});

// Page load pe bhi run kare
document.addEventListener("DOMContentLoaded", updateVariantContent);
 



// --------------------Easy Appointment page js---------------------
// setTimeout(() => {

  // const buttons = document.querySelectorAll('.ai-location-cardMn button.ailocation-card__btn');
  // console.log("Buttons:", buttons);

  // buttons.forEach(button => {

  //   button.addEventListener('click', function () {

  //     let locationName = this.getAttribute('data-location-name').toLowerCase();
  //     console.log("Location Name:", locationName);

  //     const cards = document.querySelectorAll('.sc-bXCLTC.josnQa');

  //     cards.forEach(card => {

  //       const h2 = card.querySelector('h2.sc-fHjqPf.jpKJSD');

  //       if (h2) {
  //         let title = h2.textContent.trim().toLowerCase();
  //         console.log("Title:", title);

  //         if (title.includes(locationName)) {
  //           console.log("MATCH FOUND:", locationName);
  //           card.style.display = "block";
  //         } else {
  //           card.style.display = "none";
  //         }

  //       }

  //     });

  //     const gridView = document.querySelector('.eab-grid-view');
  //     if (gridView) {
  //       gridView.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       console.log("Scrolled to .eab-grid-view");
  //     }

  //   });

  // });

// }, 3000); // 3 sec wait for app load


setTimeout(() => { // Please do not remove the `setTimeout`.
 
  let activeChangeHandler = null;
 
  // Event delegation: listen for clicks on any "Book Appointment" button.
  // This also works for cards that are rendered/re-rendered later.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ailocation-card__btn');
    if (!btn) return;
 
    // Reset all dropdowns: hide them and detach any previously attached listener
    // so old handlers don't fire with the wrong location.
    document.querySelectorAll('.cstpiercing-service').forEach(el => {
      el.classList.remove('active');
      if (activeChangeHandler) {
        el.removeEventListener('change', activeChangeHandler);
      }
    });
 
    // Show all buttons again, then hide only the clicked one
    document.querySelectorAll('.ailocation-card__btn').forEach(el => {
      el.classList.remove('hidden');
    });
    btn.classList.add('hidden');
 
    // Location comes from the clicked card's data attribute (fully dynamic)
    const locationName = btn.getAttribute('data-location-name') || '';
    console.log('Clicked location:', locationName);
 
    // Find the service dropdown inside the same card
    const parent = btn.parentElement;
    if (!parent) return;
 
    const select = parent.querySelector('.cstpiercing-service');
    if (!select) return;
 
    select.classList.add('active');
 
    // Attach the change handler for this card's dropdown
    activeChangeHandler = function (ev) {
      const service = ev.target.value.trim();
      if (service) {
        console.log('Service selected:', service, '| For location:', locationName);
        goToServiceProduct(locationName, service);
      }
    };
    select.addEventListener('change', activeChangeHandler);
  });
 
  // Normalize a string for comparison: lowercase, trim, collapse multiple spaces
  const norm = (s) => (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
 
  // Build the expected product title in EAB format: "Service - Location".
  // Special case (e.g. Knokke): if the service value already contains the
  // location name ("Les Jumelles - Knokke"), do NOT append the location again.
  function buildTitle(location, service) {
    if (norm(service).includes(norm(location))) return service;
    return `${service} - ${location}`;
  }
 
  // Convert a product title into a Shopify handle guess:
  // "Flat Piercing - Antwerp" -> "flat-piercing-antwerp"
  function toHandle(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')   // replace anything that is not a-z or 0-9 with "-"
      .replace(/^-+|-+$/g, '');      // trim leading/trailing dashes
  }
 
  // Main logic: find the matching product and redirect to it
  function goToServiceProduct(location, service) {
    const title = buildTitle(location, service);
    const handle = toHandle(title);
 
    // Respect locale prefixes like /en/ or /fr/ if the store uses them
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 
    console.log('Looking for product:', title, '| handle guess:', handle);
 
    // STEP 1: Try the guessed handle directly.
    // "/products/<handle>.js" returns product JSON only if the product exists.
    fetch(`${root}products/${handle}.js`)
      .then((r) => {
        if (!r.ok) throw new Error('handle not found');
        // Product exists -> go straight to its page
        window.location.href = `${root}products/${handle}`;
      })
      .catch(() => {
        // STEP 2 (fallback): the handle guess failed, so search the store
        // using Shopify's predictive search API and match by title instead.
        const url =
          `${root}search/suggest.json?q=${encodeURIComponent(title)}` +
          `&resources[type]=product&resources[limit]=10`;
 
        fetch(url)
          .then((r) => r.json())
          .then((data) => {
            const products =
              (data && data.resources && data.resources.results && data.resources.results.products) || [];
 
            // Prefer an exact title match; otherwise accept a product whose
            // title contains BOTH the service and the location.
            const exact = products.find((p) => norm(p.title) === norm(title));
            const partial = products.find(
              (p) => norm(p.title).includes(norm(service)) && norm(p.title).includes(norm(location))
            );
            const match = exact || partial;
 
            if (match) {
              window.location.href = match.url;
            } else {
              // Nothing matched -> log what the store actually returned so the
              // real product titles can be checked easily in the console.
              console.warn('No matching product found for:', title);
              console.log('Products returned by search:', products.map((p) => p.title));
            }
          })
          .catch((err) => console.error('Predictive search error:', err));
      });
  }
 
}, 1000); // Please do not remove this.
  // Please do not remove the `this`.